import {CommonModule} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  SectionComponent
} from '@q9elements/ui-kit/components';

import {SfConnectionInfoDialogData, SfDetailsItem} from '../../models/salesforce-orgs.interface';
import {ConnectionDetailsListComponent} from '../connection-details-list/connection-details-list.component';

declare global {
  interface Window {
    Intercom: {
      (command: string, eventName: string, metadata?: Record<string, string>): void;
    };
  }
}
@Component({
  standalone: true,
  selector: 'q9ma-sf-connection-info-dialog',
  imports: [
    CommonModule,
    TranslateModule,
    DialogCloseButtonComponent,
    MatDialogModule,
    PrimaryButtonComponent,
    SectionComponent,
    SecondaryButtonComponent,
    MatIconModule,
    ConnectionDetailsListComponent
  ],
  templateUrl: './sf-connection-info-dialog.component.html',
  styleUrls: ['./sf-connection-info-dialog.component.scss']
})
export class SfConnectionInfoDialogComponent implements OnInit {
  public readonly data = inject<SfConnectionInfoDialogData>(MAT_DIALOG_DATA);
  public readonly dialogRef = inject(MatDialogRef<SfConnectionInfoDialogComponent>);

  public detailsItems: SfDetailsItem[] = [];

  public ngOnInit() {
    this.initDetailItems();
  }

  public initDetailItems(): void {
    this.detailsItems = [
      {
        title: 'SF_CONNECTIONS.INTEGRATION_USER',
        icon: 'person',
        value: this.data.username
      },
      {
        title: 'SF_CONNECTIONS.ORG_DOMAIN',
        icon: 'globe',
        value: this.data.orgDomain || ''
      },
      {
        title: 'SF_CONNECTIONS.ENVIRONMENT',
        icon: 'database',
        value: this.data.isSandbox ? 'Sandbox' : 'Production'
      },
      {
        title: 'SF_CONNECTIONS.SYNC_SCHEDULE',
        icon: 'calendar_new',
        value: this.data.manualSyncOnlyEnabled
          ? 'Manual Sync Only enabled'
          : `Daily at ${this.toAmPm(this.data.uiTime)}`
      }
    ];
  }

  private toAmPm(time: string) {
    const TIME_24H_REGEX = /^(?:[01]?\d|2[0-4]):[0-5]\d$/;

    if (!TIME_24H_REGEX.test(time)) {
      return 'Invalid time format';
    }

    const [h, m] = time.split(':');
    let hNum: number = Number(h);

    if (hNum === 24) {
      hNum = 0;
    }

    const hour = hNum % 12 || 12;
    const period = hNum < 12 ? 'AM' : 'PM';

    return `${hour}:${m} ${period}`;
  }

  public acknowledge(): void {
    this.dialogRef.close();
  }

  public completeSetup(): void {
    this.dialogRef.close();
  }
}
